import * as authorAllFeedActions from '../../action_creators/author/author_all_feed_action_creators';
import AuthorAllFeedModel from '../../../models/author/author_all_feed';
import log from '../../../services/logger_service';

export default function fetchAuthorAllFeedIS(dispatch) {
  return function fetchModelData(params, config) {
    dispatch(authorAllFeedActions.authorAllFeedISLoading());
    return AuthorAllFeedModel.fetchAllFeedIS(params, config)
      .then(function handleAuthorAllFeedData(authorAllFeedData) {
        dispatch(
          authorAllFeedActions.authorAllFeedISLoaded(
            authorAllFeedData.data,
            config
          )
        );
      })
      .catch(function handleAuthorAllFeedError(err) {
        dispatch(authorAllFeedActions.authorAllFeedISError(err, config));
        log.error(
          err,
          `Error in all author all feed actions, message: ${err.message}`
        );
      });
  };
}
